export default __webpack_public_path__ + "static/media/sloth.62d72160.png";